export const DownloadIcon = () => (
  <svg fill="#027DBC" width="15px" height="15px" viewBox="0 0 498.779 498.779">
    <polygon points="498.779,366.435 452.881,366.435 452.881,439.875 45.9,439.875 45.9,367.965 0,367.965 0,485.774 498.779,485.774" />
    <polygon points="134.086,177.664 70.334,177.664 254.209,406.215 438.082,177.664 374.332,177.664 374.332,13.005 134.086,13.005" />
  </svg>
);

export default DownloadIcon;
